import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Flex,
  Text,
  Button,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { getAccount, updateUser } from "../../utils/sessionHelper";
import { SortType, sortPosts, sortValuesByMode, defaultFilters, ENGAGE_FILTER_KEY, sleep } from "./utils";
import { FiFilter } from "react-icons/fi";
import { FiltersPopup } from "./filters-popup";
import { BsChevronDown } from "react-icons/bs";
import { layerStyle, textStyle, variant } from "theme/names";
import { RefreshIcon } from "../icons/refresh";
import { FSRAProps } from "./custom-types";

export const FilterSortRefreshAutoLike = ({
  session,
  isAuthenticated,
  data,
  onRefreshButtonClickCallBack = (data) => { },
  onFilterCallback = (data) => { },
  onAutoLikeCallback = () => { },
  onSortCallback = (data) => { },
  filters = defaultFilters,
  mode = "bestforyou",
  isLoadingPosts = false,
  isRefreshSecondary = false,
  animateRefresh = false,
}: FSRAProps) => {
  const defaultSortType = (mode === "bestforyou") ? SortType.MOST_RELEVANT : SortType.MOST_RECENT;
  const filterDisclosure = useDisclosure();
  const [sortby, setSortby] = useState(defaultSortType);
  const [autoLike, setAutoLike] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<any>(data);

  const handleRefreshButtonClick = async () => {
    await onRefreshButtonClickCallBack(filterData);
    setSortby(defaultSortType);
    // const sortedData = sortPosts(data, sortby);
    // await onSortCallback(sortedData);
  }

  const onAutoLike = async (e) => {
    await updateUser(session, { autoLikeOnReply: !autoLike });
    setAutoLike(!autoLike);
    await onAutoLikeCallback();
  }

  const applyFilters = async (filters) => {
    localStorage.setItem(ENGAGE_FILTER_KEY, JSON.stringify(filters));
    await sleep(1000); //wait for localstorage to set item before reloading data - fix for race conditions.
    setSortby(defaultSortType);
    await onFilterCallback(filters);
  }

  useEffect(
    () => {
      setAutoLike(getAccount(session)?.autoLikeOnReply);
      // add "autoLikeOnReply" key to user object if not found.
      if (session && getAccount(session)?.autoLikeOnReply === undefined) {
        updateUser(session, { autoLikeOnReply: true });
        setAutoLike(true);
      }
    }, [session]
  );

  useEffect(
    () => {
      const sortedData = sortPosts(filterData, sortby);
      onSortCallback(sortedData);
    }, [sortby]
  );

  useEffect(
    () => {
      const sortedData = sortPosts(data, sortby);
      setFilterData(sortedData);
    }, [data]
  );

  //if(!filterData?.length && mode === "people") return null;

  return (
    <>
      <Flex flexDirection={"column"} mt={5}>
        <Box
          alignSelf={"end"}
          p="4"
          width={"fit-content"}
          layerStyle={layerStyle["bg.border.rounded"]}
        >
          <Checkbox
            ml={1}
            onChange={onAutoLike}
            isChecked={autoLike}
            isDisabled={!isAuthenticated || isLoadingPosts}
          >
            auto-like post when replying
          </Checkbox>
        </Box>
        <Box
          pt="3"
          w="100%"
        >
          <Flex
            position="relative"
            justifyContent="space-between"
            alignItems="center"
            gap={3}
            flexDir={{ base: "column", md: "row" }}
          >
            <Text
              justifySelf="center"
              textStyle={textStyle["body.medium.light"]}
              fontWeight="600"
            >
              {
                (filterData?.length > 0) &&
                filterData?.length + " posts found to engage with"
              }
            </Text>

            <Flex
              gap="3"
              position="relative"
              justifyContent="space-between"
              alignItems="center"
            >
              {(mode != "replytocomments") &&
                <>
                  <Button
                    variant="ghost"
                    size="sm"
                    rightIcon={<FiFilter style={{ marginTop: "2px" }} />}
                    onClick={filterDisclosure?.onOpen}
                    isDisabled={!isAuthenticated || isLoadingPosts}
                  >
                    Filters
                  </Button>
                  <Menu >
                    <Text textStyle={textStyle["body.medium.light"]}>Sort by</Text>
                    <MenuButton
                      as={Button}
                      size="sm"
                      variant="outline"
                      rightIcon={<BsChevronDown />}
                      ml="0"
                      isDisabled={!isAuthenticated || isLoadingPosts}
                    >
                      <Text maxW="200px" noOfLines={1} wordBreak="break-all">
                        {sortby}
                      </Text>
                    </MenuButton>
                    <MenuList maxH="215px" overflow="scroll">
                      {sortValuesByMode[mode].map((value) => (
                        <MenuItem key={value} onClick={() => setSortby(value)}>
                          {value}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </Menu>
                </>
              }
              <Button
                variant={isRefreshSecondary ? "secondary" : "primary"}
                ml={3}
                isDisabled={!isAuthenticated || isLoadingPosts}
                leftIcon={<RefreshIcon isLoading={isLoadingPosts && animateRefresh} />}
                onClick={handleRefreshButtonClick}
                borderColor={isRefreshSecondary ? "0A66C2" : ""}
              >
                {animateRefresh ?
                  isLoadingPosts
                    ? "Refreshing..."
                    : "Refresh"
                  : "Refresh"}
              </Button>
            </Flex>
          </Flex>
        </Box>
      </Flex>
      <FiltersPopup
        isOpen={filterDisclosure?.isOpen}
        onClose={filterDisclosure?.onClose}
        filters={filters}
        onApplyFilters={applyFilters}
      />
    </>
  )
}